import React from "react";

import { InformationalModal } from "components/botanic/Modal";

type Props = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: fix me please, do not replicate
  returnFocusRef: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: fix me please, do not replicate
  toggleShowTaxModal: any;
};

const TaxModal = ({ returnFocusRef, toggleShowTaxModal }: Props) => {
  const taxModalId = "tax-estimation-modal";

  return (
    <InformationalModal
      aria-labelledby={taxModalId}
      returnFocusRef={returnFocusRef}
      onDismissed={toggleShowTaxModal}
    >
      <div id={taxModalId} className="heading--m">
        How taxes are estimated
      </div>

      {[
        {
          body: "All taxes displayed on Leafly are estimates. Final purchase price will be determined at the time of payment.",
        },
        {
          body: "When you pay for your pickup or delivery order, taxes will be added (if applicable) by the merchant to the purchase price of your Leafly order based on taxes in your location.",
          title: "Tax is ‘calculated at payment’",
        },
        {
          body: "The prices of products displayed on Leafly already include the applicable taxes.",
          title: "Tax is ‘included in pricing’",
        },
        {
          body: "This estimates the state and local sales taxes applied to all items in your order.",
          title: "Sales tax",
        },
        {
          body: "This estimates the taxes that your state and/or local municipality applies to cannabis products. This tax is typically not applied to accessories and other non-infused products.",
          title: "Excise tax",
        },
        {
          body: "Some states and local municipalities require retailers to pay ‘additional’ taxes (usage fees, surcharges, etc.) on sales. Retailers may include these taxes in their product prices or add them to your total at checkout.",
          title: "Additional tax",
        },
      ].map((copy, index) => (
        <div className="text-sm mt-lg" key={index}>
          {copy.title && <div className="font-bold">{copy.title}</div>}

          {copy.body && <div>{copy.body} </div>}
        </div>
      ))}
    </InformationalModal>
  );
};

export default TaxModal;
